<template>
  <FoodleapSimplifiedActorDetail v-if="shouldShowAugmentedProfile"/>
  <SimplifiedActorDetail v-else-if="shouldShowActorSimplifiedDetailPage || this.isProduct"/>
  <ActorDetail v-else/>
</template>

<script lang="ts">
  import ActorDetail from './ActorDetail.vue'
  import FoodleapSimplifiedActorDetail from './FoodleapSimplifiedActorDetail.vue'
  import SimplifiedActorDetail from './SimplifiedActorDetail.vue'
  import UiMixin from '../../util/UiMixin.js'
  import { defineComponent } from 'vue'

  export default defineComponent({
    components: { FoodleapSimplifiedActorDetail, SimplifiedActorDetail, ActorDetail },
    mixins: [UiMixin],
    computed: {
      currentActor() {
        // This object always contains the data for the current view actor detail page
        return this.$store.getters.detailActor
      },
      isProduct() {
        return this.currentActor && this.currentActor['actor_type'] === 'Product'
      },
      /**
       * On Foodleap the Augmented Actor Profile *is* the actor detail page for the people it was
       * written for — actors and anonymous visitors. The page gates its members-only sections
       * itself rather than being kept behind a route guard.
       *
       * Three ways out of it, all deliberate:
       *   · Ecosystem owners and members default to the classic page. The augmented profile is an
       *     outward-facing story; their job needs the database entry behind it.
       *   · `/actors/:id/classic` — the "Classic profile" button in the augmented profile's top
       *     bar. Owners only there, but the route works for anyone who has the link.
       *   · Products keep the classic page: the augmented profile is written about organisations
       *     (transitions, roles, capabilities), and none of it applies to a product.
       *
       * Every other ecosystem is unchanged; /actors/:id/aap remains the preview route for them.
       */
      shouldShowAugmentedProfile() {
        if (!this.$store.getters.isFoodleap || this.isProduct) {
          return false
        }

        // Owners and members keep the classic page as their default, the same way
        // shouldShowActorSimplifiedDetailPage already excludes them from the simplified one. It
        // carries the tooling they actually work in — notes, changes, suggestions, duplicates,
        // relevancy, the edit panel — none of which the augmented profile has or should have. They
        // reach the augmented profile from the "Augmented profile" button in the classic top bar.
        /*if (this.isOwner || this.isMember) {
          return false
        }*/

        return !this.isClassicProfileRequested
      },
      /**
       * `/actors/:id/classic` is the addressable form and what the augmented profile's own button
       * uses. It is an *alias* of the actor-detail route, not a route of its own — see the router —
       * so it is the path, not the route name, that says which one was asked for.
       *
       * `?profile=classic` came first and still answers: this page is also rendered embedded in the
       * spotting-area and community pages, whose routes are `/:section?/:id?` and have no path
       * segment left to spend, so the query is the only way to ask there.
       */
      isClassicProfileRequested() {
        return this.$route.path.replace(/\/+$/, '').endsWith('/classic') ||
          this.$route.query.profile === 'classic'
      },
    },
  })
</script>
